import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import "./Links.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <p>&copy; {new Date().getFullYear()} Inti. Todos os direitos reservados.</p>
        <div className="links">
          <Link className="link" to="/privacy">
            Política de privacidade
          </Link>
          <Link className="link" to="/terms">
            Termos de uso
          </Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
